import { root_props } from '../main';

export function has_transsion_board() {
    return ['nick.wang@bidderdesk.com', 'li.tian@bidderdesk.com', 'john@bidderdesk.com'].includes(root_props.user.email)
}

export function is_manager() {
    return ['nick.wang@bidderdesk.com', 'li.tian@bidderdesk.com', 'john@bidderdesk.com',
        'vincent.gao@bidderdesk.com', 'lv@bidderdesk.com', 'celine@bidderdesk.com', 'tony.zhang@bidderdesk.com'].includes(root_props.user.email)
}

export function is_mi() {
    return ['mi.op@bidderdesk.com'].includes(root_props.user.email)
}

export function is_oppo() {
    return ['oppo.op@bidderdesk.com'].includes(root_props.user.email)
}

export function is_super_user() {
    return ['li.tian@bidderdesk.com'].includes(root_props.user.email)
}

export function is_business_manager() {
    return ['long.jiang@bidderdesk.com'].includes(root_props.user.email)
}

/** 当前用户是否具有 PM 角色（全部产品权限） */
export function is_pm() {
    return (root_props.user.authority || []).includes('pm')
}